import Status from './status';

export default ({active, onClick, bonus}) => (
    <div className={`method-20 ${!active ? 'not-available' : ''}`} onClick={e => {
        if(!active)
            return;

        // toast.dismiss();
        // toast.info('Chime under maintenance now. Use CashApp or Debit Card to make deposits');

        onClick({
            mode: "methods",
            method: "chime-deposit"
        });
    }}>
        <div className="info">
            <div className="icon chime">
                <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.26421 16C10.9565 16 12.8645 14.9825 14 14.1287V10.4211C12.3261 11.7427 10.3595 12.5029 8.61538 12.5029C5.82943 12.5029 3.87458 10.5848 3.87458 7.82456C3.87458 5.20468 5.65385 3.38012 8.19398 3.38012C9.02508 3.38012 9.73913 3.59064 10.5 3.80117C11.2843 4.02339 12.1037 4.26901 13.0753 4.26901C13.3796 4.26901 13.6839 4.24561 13.9883 4.19883V0.666667C13.7308 0.690059 13.4849 0.713451 13.2274 0.713451C12.3495 0.713451 11.5535 0.549708 10.7224 0.374269C9.84448 0.187135 8.94314 0 7.87793 0C5.7592 0 3.79264 0.748539 2.35284 2.12866C0.819398 3.59064 0 5.62573 0 8C0 12.7135 3.39465 16 8.26421 16Z" fill="white"/>
                </svg>
            </div>

            <Status available={active} bonus={0} deposit_bonus={bonus} fee={0} />
        </div>

        <div className="name">Chime</div>
    </div>
)